import React from 'react';
import {ContainerBox, ContainerUploadTitleBox, SubtitleUpload, UploadOutlinedIconSmall, A} from '../Style/DragAndDropUploadData.style';
import LoadDataBtn from '../../../Presentational Components/LoadDataBtn';
import uploadIcon from '../../../images/upload_blue.png';
import useDropFiles from '../../../Custom Hooks/useDropFiles/useDropFiles';
import {IPropsView} from '../Config/DragAndDropUploadData.types';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';

const DragAndDropUploadData = ({backgroundColor, backgroundColorDefault, getChosenFiles}:IPropsView) => {
    const cssObj = backgroundColor ? {cssSelectorKey: 'backgroundColor', cssSelectorKeyValue: backgroundColor, cssSelectorKeyValueDefault: backgroundColorDefault} : {};
    const { drop} = useDropFiles(cssObj, getChosenFiles);


    return (
        <ContainerBox ref={drop}>
            <UploadOutlinedIconSmall />
            <ContainerUploadTitleBox >
                <SubtitleUpload >{_SYSTEM_TITLES.dragAndDrop}</SubtitleUpload>
                <LoadDataBtn
                    classNameBtn=''
                    accept='image/*'
                    btnTitle={_SYSTEM_TITLES.upload}
                    multiple={true}
                    onUploadFiles={(e) => getChosenFiles(e.target.files)}
                    uploadImageSrc={uploadIcon}
                    uploadOnlyOneFile={() => {}} >
                    <A>{_SYSTEM_TITLES.upload}</A>
                </LoadDataBtn>
            </ContainerUploadTitleBox>
        </ContainerBox>
    );

};

export default DragAndDropUploadData;
